import { Constant, Headers } from "../apiConstants";

const UserTraction = async({EventNo, OutletType="", SearchText="", SelectedOutlet=0, PayBillClick=false, PayNowClick=false, SelectedOfferId=0}) => {
    const endpoint = Constant.USER_TRACTION;
    const BaseUrl = Constant.BASE_URL;
    try {
      const response = await fetch(BaseUrl + "/" + endpoint, {
        method: "post",
        headers: Headers,
        body: JSON.stringify({
          EventType: EventNo,
          ClickedResturantType: OutletType,
          OutletSearched: SearchText,
          ClickedOutletId: SelectedOutlet,
          PayBillPage: PayBillClick,
          PayNowClicked: PayNowClick,
          ClickedOfferId: SelectedOfferId
        }),
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error(error);
      throw error;
    }
}

export default UserTraction;